import { FunctionComponent, memo } from 'react'

import isEqual from 'fast-deep-equal'
import Head from 'next/head'

import { withValidSchemaContext } from '@components/Schema/utils'

interface SchemaHTMLElementProps {
  scriptKey: string
  schemaObject: Record<string, unknown>
}

const SchemaHTMLElement: FunctionComponent<SchemaHTMLElementProps> = ({
  scriptKey,
  schemaObject,
}) => (
  <Head>
    <script
      key={scriptKey}
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(withValidSchemaContext(schemaObject)),
      }}
    />
  </Head>
)

const MemoizedSchemaHTMLElement = memo(
  SchemaHTMLElement,
  (prevProps, nextProps) => isEqual(prevProps, nextProps),
)

MemoizedSchemaHTMLElement.displayName = 'MemoizedSchemaHTMLElement'

export default MemoizedSchemaHTMLElement
